import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ActiveVasOfferStatusCssClasses } from "../ActiveVasOffersUIHelpers";
import * as actions from "../../../_redux/activeVasOffers/activeVasOffersActions";
import { useActiveVasOffersUIContext } from "../ActiveVasOffersUIContext";

const selectedActiveVasOffers = (entities, ids) => {
  const _activeVasOffers = [];
  ids.forEach((id) => {
    const activeVasOffer = entities.find((el) => el.id === id);
    if (activeVasOffer) {
      _activeVasOffers.push(activeVasOffer);
    }
  });
  return _activeVasOffers;
};

export function ActiveVasOffersUpdateStatusDialog({ show, onHide }) {
  // ActiveVasOffers UI Context
  const activeVasOffersUIContext = useActiveVasOffersUIContext();
  const activeVasOffersUIProps = useMemo(() => {
    return {
      ids: activeVasOffersUIContext.ids,
      setIds: activeVasOffersUIContext.setIds,
      queryParams: activeVasOffersUIContext.queryParams,
    };
  }, [activeVasOffersUIContext]);

  // ActiveVasOffers Redux state
  const { activeVasOffers, isLoading } = useSelector(
    (state) => ({
      activeVasOffers: selectedActiveVasOffers(state.activeVasOffers.entities, activeVasOffersUIProps.ids),
      isLoading: state.activeVasOffers.actionsLoading,
    }),
    shallowEqual
  );

  // if there weren't selected activeVasOffers we should close modal
  useEffect(() => {
    if (activeVasOffersUIProps.ids || activeVasOffersUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeVasOffersUIProps.ids]);

  const [status, setStatus] = useState(0);

  const dispatch = useDispatch();
  const updateStatus = () => {
    // server request for updateing activeVasOffer by ids
    dispatch(actions.updateActiveVasOffersStatus(activeVasOffersUIProps.ids, status)).then(
      () => {
        // refresh list after deletion
        dispatch(actions.fetchMyActiveVasOffers()).then(
          () => {
            // clear selections list
            // activeVasOffersUIProps.setIds([]);
            // closing delete modal
            onHide();
          }
        );
      }
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Status has been updated for selected activeVasOffers
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overlay overlay-block cursor-default">
        {isLoading && (
          <div className="overlay-layer bg-transparent">
            <div className="spinner spinner-lg spinner-warning" />
          </div>
        )}
        <div className="list-timeline list-timeline-skin-light padding-30">
          <div className="list-timeline-items">
            {activeVasOffers.map((activeVasOffer) => (
              <div className="list-timeline-item mb-3" key={activeVasOffer.id}>
                <span className="list-timeline-text">
                  <span
                    className={`label label-lg label-light-${
                      ActiveVasOfferStatusCssClasses[activeVasOffer.status]
                    } label-inline`}
                    style={{ width: "60px" }}
                  >
                    ID: {activeVasOffer.id}
                  </span>{" "}
                  <span className="ml-5">
                    {activeVasOffer.manufacture}, {activeVasOffer.model}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="form">
        <div className="form-group">
          <select
            className={`form-control ${ActiveVasOfferStatusCssClasses[status]}`}
            value={status}
            onChange={(e) => setStatus(+e.target.value)}
          >
            <option value="0">Selling</option>
            <option value="1">Sold</option>
          </select>
        </div>
        <div className="form-group">
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={updateStatus}
            className="btn btn-primary btn-elevate"
          >
            Update Status
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
